import React from 'react'
import styled from 'styled-components'
import Fade from 'react-reveal/Fade'
import Container from './container'
import {stripMarkup} from './../helper-functions/strip-markup'

export default function WorkIntroText({html}) {
  return (
    stripMarkup(html) && (
      <Container>
        <Fade>
          <StyledComponent dangerouslySetInnerHTML={{__html: html}} />
        </Fade>
      </Container>
    )
  )
}

const StyledComponent = styled.div`
  font-weight: 100;
  margin-bottom: 3rem;
  max-width: 56rem;
`
